(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('base', {
            parent: 'script',
            url: '/base',
            data: {
                pageTitle: 'global.menu.system.base'
            },
            views: {
                'content@': {
                    templateUrl: 'app/system/script/base/base.html',
                    controller: 'BaseController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                // 文字
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('base');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
